// sessionStorage キー (localStorage は spec/components/worker-facade/auth-routing.md で禁止)
// SPA login flow (spec/components/worker-facade/auth-routing.md / 2026-04-20〜) では
// PKCE verifier / state は spaLogin 内の local 変数で扱い sessionStorage に保存しない。
const KEYS = {
  clientId: 'kdb_client_id',
  accessToken: 'kdb_access_token',
  expiresAt: 'kdb_token_expires_at'
} as const

export const storage = {
  getClientId(): string | null {
    return sessionStorage.getItem(KEYS.clientId)
  },
  setClientId(v: string): void {
    sessionStorage.setItem(KEYS.clientId, v)
  },
  getAccessToken(): string | null {
    const token = sessionStorage.getItem(KEYS.accessToken)
    const expiresAt = sessionStorage.getItem(KEYS.expiresAt)
    if (!token || !expiresAt) return null
    if (Date.now() >= parseInt(expiresAt, 10)) {
      this.clearTokens()
      return null
    }
    return token
  },
  setAccessToken(token: string, expiresIn: number): void {
    sessionStorage.setItem(KEYS.accessToken, token)
    sessionStorage.setItem(KEYS.expiresAt, String(Date.now() + expiresIn * 1000 - 60_000))
  },
  clearTokens(): void {
    sessionStorage.removeItem(KEYS.accessToken)
    sessionStorage.removeItem(KEYS.expiresAt)
  },
  clearAll(): void {
    Object.values(KEYS).forEach((k) => sessionStorage.removeItem(k))
  }
}
